import React, { useState } from "react";
import { Table, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import CommonButton from "../commonButton";
import { FormLabel } from "../form/utils";
import CustomSelect from "../form/CustomSelect";
import { InformationCircleIcon } from "../../assets/icons";
import withModal from "../withModal";
import { useToast } from "../../context/TostContext";

const ImportModalInner = ({
  onClose,
  users = [],
  onSubmit,
  onDownloadSample,
}) => {
  const toast = useToast();
  const [selectedUserId, setSelectedUserId] = useState("");
  const [csvFileName, setCsvFileName] = useState("");
  const [csvData, setCsvData] = useState(null);
  const [importApiErr, setImportApiErr] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const selectedUserFromDropdown = users.find((user) => user.id === selectedUserId);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      toast.error("No file chosen");
      return;
    }
    setCsvFileName(file.name);
    setCsvData(file);
  };

  const handleImportSubmit = async () => {
    if (!csvData) {
      toast.error("Please upload a file before submitting.");
      return;
    }
    setIsSubmitting(true);
    setImportApiErr("");
    try {
      await onSubmit(csvData, selectedUserId);
      onClose();
    } catch (error) {
      setImportApiErr(error?.message || "Failed to Add Import Properties!");
      toast.error(error?.message || "Failed to Add Import Properties!");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal.Body className="text-center px-4">
       <div className="text-start">
          <CustomSelect
            label={{ name: "Select User" }}
            value={selectedUserId}
            onChange={(name, val) => setSelectedUserId(val)}
            options={users.map((user) => ({
              value: user.id,
              label: user.label,
            }))}
            placeholder="Select User"
            isSearchable={true}
          />
          {selectedUserFromDropdown && (
            <>
              <div className="mt-4">
                <FormLabel labelName="Bank Details" />
                <div className="table-responsive rounded-2 border">
                  <Table className="tbl-content mb-0">
                    <thead>
                      <tr>
                        <th className="text-capitalize fw-normal border-0 text-start py-1 px-4 bg-white">
                          Bank Name
                        </th>
                        <th className="text-capitalize fw-normal border-0 text-start py-1 px-4 bg-white">
                          Branch
                        </th>
                        <th className="text-capitalize fw-normal border-0 text-start py-1 px-4 bg-white">
                          City
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border-0 py-2 px-4">
                          {selectedUserFromDropdown?.bankName || "N/A"}
                        </td>
                        <td className="border-0 py-2 px-4">
                          {selectedUserFromDropdown?.branchName || "N/A"}
                        </td>
                        <td className="border-0 py-2 px-4">
                          {selectedUserFromDropdown?.city || "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="mt-4">
                <FormLabel labelName="Import File" />
                <div className="border position-relative cursor-pointer custom-import-file rounded-2 overflow-hidden">
                  <div>{csvFileName ? csvFileName : "Choose file"}</div>
                  <span className="px-3 text-white d-flex align-items-center justify-content-center position-absolute top-0 bottom-0 end-0">
                    Browse
                  </span>
                  <input
                    type="file"
                    accept=".csv, .xlsx"
                    onChange={handleFileUpload}
                    className="position-absolute top-0 bottom-0 cursor-pointer start-0 end-0 opacity-0"
                  />
                </div>
              </div>
            </>
          )}
        </div>

        <div className="text-center" style={{ width: "50%", margin: "0 auto" }}>
          <CommonButton
            title={isSubmitting ? "Importing..." : "Import"}
            type="submit"
            className="w-100 btn-primary primary-shadow my-4"
            onClick={handleImportSubmit}
            disabled={!csvData || isSubmitting}
          />
          {importApiErr && (
            <div className="alert alert-danger mt-3">
              <p>{importApiErr}</p>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center text-start justify-content-between">
          {onDownloadSample ? (
            <p className="cursor-pointer text-decoration-underline" onClick={onDownloadSample}>
              Download Sample CSV File
            </p>
          ) : (
            <p className="cursor-pointer text-decoration-underline text-secondary">
              Download Sample CSV File
            </p>
          )}
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 250 }}
            overlay={
              <Tooltip id="button-tooltip">
                Please send your CSV file in the correct format as mentioned
                in Download Sample CSV file (including headers and values)
                to avoid any kind of rejections.
              </Tooltip>
            }
          >
            <i className="cursor-pointer d-flex align-items-center justify-content-center primary">
              <InformationCircleIcon size={20} />
            </i>
          </OverlayTrigger>
        </div>
    </Modal.Body>
  );
};

const ImportModal = withModal(ImportModalInner);
export default ImportModal;